import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Container } from "reactstrap";
import Header from "../../../components/Headers/Header";

import { getActiveStudentData } from "../../../Services/Reports/ReportService";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";
import { STATE_OFFICIAL_PATHS } from "../../../routes";
import { ArrowLeft, ArrowRight } from "react-bootstrap-icons";
import Filter from "../Components/Filter/Filter";
import moment from "moment";
import StatCard from "../../../components/Cards/StatCard";

export default function EnrolledStudents() {
  const history = useHistory();

  // loading
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [activeData, setActiveData] = useState<
    | {
        active_users: number;
        assessment_attempted_students: number;
        assessment_created_by: number;
      }
    | undefined
  >();
  const [dateRange, setDateRange] = useState<{
    start_date: string;
    end_date: string;
  }>({
    start_date: moment().format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    setIsLoading(true);
    getActiveStudentData(dateRange)
      .then((res) => {
        setActiveData(res?.data);
      })
      .finally(() => setIsLoading(false));
  }, [dateRange]);
  return (
    <React.Fragment>
      <Header />
      <Container className="mt--9" fluid>
        <div className="my-3">
          <Button
            color="secondary"
            size="sm"
            onClick={() => history.push(STATE_OFFICIAL_PATHS.reports)}
          >
            <ArrowLeft /> Go Back
          </Button>
        </div>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <div className="d-flex justify-content-between">
              <h3 className="mb-0 text-muted">
                <i className="fas fa-file-invoice mr-1"></i> Active users from{" "}
                {moment(dateRange?.start_date).format("DD MMM, YYYY")} to{" "}
                {moment(dateRange?.end_date).format("DD MMM, YYYY")}
              </h3>
              <div></div>
            </div>

            <div className="pt-2">
              <Filter
                hasDateFilter
                onSearch={(value) => {
                  const date = value?.date;
                  setDateRange(date);
                }}
                onClear={() => {}}
              />
            </div>
          </CardHeader>

          <CardBody>
            {!isLoading ? (
              <div>
                {activeData ? (
                  <div style={{ display: "flex", gap: "1em" }}>
                    <StatCard
                      title={`User${activeData?.active_users > 1 ? "s" : ""}`}
                      stat={activeData?.active_users || 0}
                      label="Based on app usages (includes students & teachers)"
                    />
                    <StatCard
                      title={`Student${
                        activeData?.assessment_attempted_students > 1 ? "s" : ""
                      }`}
                      stat={activeData?.assessment_attempted_students || 0}
                      label="Based on assessments attempted"
                    />
                    <StatCard
                      title={`Teacher${
                        activeData?.assessment_created_by > 1 ? "s" : ""
                      }`}
                      stat={activeData?.assessment_created_by || 0}
                      label="Based on assessments created"
                    />
                  </div>
                ) : (
                  <div className="w-100 d-flex justify-content-center">
                    No activity found for selected date range.
                  </div>
                )}
              </div>
            ) : (
              <DotsSpinner />
            )}
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
}
